import { render } from "./AppSpinner.vue?vue&type=template&id=2e12222f&ts=true"
import script from "./AppSpinner.vue?vue&type=script&lang=ts"
export * from "./AppSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__